import React, { Component, useState } from "react"
import { Pie } from 'react-chartjs-2';
import { MDBBtn, MDBIcon } from "mdbreact";
import { Card, Collapse, CardTitle, CardBody, Col, Container, Media, Label, Input, Row } from 'reactstrap';
import { Link } from "react-router-dom";
import ApiRest from "../../ayudas/apiRest";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import toastr from "toastr";
import Select from 'react-select';
import _valid from "../../validations";
import { LabelRounded } from "@material-ui/icons";

export default class graficaHoras extends Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest();

        this.state = {
            colapsar: true,
            datos: [],
            data: [],
            opciones: [],
            fechaFin: null,
            fechaMin: null,
            lugar_ubicacion: null,
            tipo_solicitud: null,
            solicitar_a: null,
            departamentosAreas: [],
            tiempo: 0
        };
        this.getInformacion = this.getInformacion.bind(this);
        this.buscar = this.buscar.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem("array");
        this.getInformacion();
        let id = null;
        id = this.apiRest.getLS('du').colaborador.id;
        if (this.apiRest.getRol()) {
            this.getDepartamentoArea();
        } else {
            this.obtenerDepartamentoLoggeado(id);
        }

    }

    obtenerDepartamentoLoggeado = (id) => {
        if (_valid(id)) {
            this.apiRest.get('/departamentoLoggeado/' + id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentosAreas: this.formatoLabel(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    getDepartamentoArea = () => {
        //obtener departamento
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoTexto(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoLabel = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));
    formatoTexto = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    cambiosUbicacion = lugar => {
        this.setState({ lugar_ubicacion: lugar });
    }

    cambiosSolicitarA = asignado => {
        this.setState({ solicitar_a: asignado });
        if (_valid(asignado)) {
            this.getTipoSolicitud(asignado.value);
        } else {
            this.setState({ tiposSolicitudes: [] });
        }
    }

    cambiosSolicitud = solicitud => {
        this.setState({ tipo_solicitud: solicitud });
        if (_valid(solicitud)) {
            this.datosGrafica(solicitud.value)
        }
    }

    datosGrafica = (id)=>{
        this.apiRest.get('/tipoSolicitudGrafica/'+id).then(resultado => {
            if (resultado.exitoso) {
                if(_valid(resultado.data[0].horas)){
                    this.setState({ tiempo: resultado.data[0].horas});
                }
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //formatear la seleccion
    formato = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));

    async getInformacion() {
        //obtener ubicacion
        this.apiRest.get('/ubicacion').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ ubicaciones: this.formatoUbicacion(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    getTipoSolicitud = (id) => {
        //obtener tipo de solicitudes
        this.apiRest.get('/tipoSolicitudPorDepartamento/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tiposSolicitudes: this.formato(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    getData = (filtro) => {
        this.apiRest.put('/graficaHora', filtro).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ datos: respuesta.data });
                this.configurarGrafica();
                window.localStorage.setItem('array', JSON.stringify(respuesta.data));
            } else {
                toastr.error('Por favor intenta nuevamente.');
                this.props.history.push('/Timeout');
            }
        });
    }

    //valida si todos los campos estan vacios
    validar = (filtro) => {
        let boleano = false;
        if (_valid(filtro.solicitar)) {
            if (_valid(filtro.tipo)) {
                boleano = true
            } else {
                toastr.error('Seleccione Tipo de Solicitud');
            }
        } else {
            toastr.error('Seleccione un Departamento u Area');
        }
        return boleano;
    }

    borrarFiltros = () =>{
        this.setState({fechaFin: null, fechaMin: null, solicitar_a: null, lugar_ubicacion: null,tiposSolicitudes:[], tipo_solicitud: null})
        this.setState({fechaFin: '', fechaMin:'', solicitar_a: '',tipo_solicitud:'', lugar_ubicacion: ''})
    }

    exportarData = (datos) => {
        let array = null;
        array = datos
        if (_valid(array)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/graficaExcel", headers).then(resp => {
                    if (resp.status >= 200 && resp.status < 300) {
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            // the filename you want
                            a.download = "grafica.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        });
                    } else if (resp.status === 401) {
                        this.props.history.push('/Timeout');
                    }
                });
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    descargarExcel = async () => {
        let array = JSON.parse(localStorage.getItem('array'));
        if (_valid(array)) {
            array = JSON.parse(localStorage.getItem('array'));
            this.exportarData(array);
            localStorage.removeItem("array");
        } else {
            toastr.error('No hay datos para procesados realize una busqueda primero');
        }
    }

    buscar = () => {
        const {
            fechaMin,
            fechaFin,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud
        } = this.state

        let solicitar = null;
        let lugar = null;
        let tipo = null;
        if (_valid(solicitar_a)) {
            solicitar = solicitar_a.value;
        }
        if (_valid(lugar_ubicacion)) {
            lugar = lugar_ubicacion.value;
        }
        if (_valid(tipo_solicitud)) {
            tipo = tipo_solicitud.value;
        }

        const filtro = {
            fechaMin,
            fechaFin,
            solicitar,
            lugar,
            tipo
        }

        if (this.validar(filtro)) {
            this.getData(filtro);
        }

    }

    configurarGrafica() {

        let labels = [];
        let datosGrafica = [];
        this.state.datos.forEach(rango => {
            labels.push(rango.etiqueta);
            datosGrafica.push(rango.porcentaje)
        });

        //console.log(labels, datosGrafica)
        const data = {
            labels: labels,
            datasets: [{
                data: datosGrafica,
                backgroundColor: [
                    '#F31152',
                    '#F3E911',
                    '#1EB206',
                ],
                borderColor: [
                    '#0C0C0C',
                    '#0C0C0C',
                    '#0C0C0C',
                ],
                borderWidth: 2,
            }]
        };
        const opciones = {
            responsive: true,
            maintainAspectRation: false,
            pieceLabel: {
                render: function (args) {
                    return args.label + " " + args.value + "%"
                },
                fontSize: 25,
                fontColor: '#110700',
                fontFamily: 'Tahoma'
            }
        }
        this.setState({ data: data, opciones: opciones });
    }

    vista(args) {
        return args.label + " " + args.value + "%"
    }

    render() {
        const {
            colapsar,
            array
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem="Gráfica Tipo de Solicitudes" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Gr&aacute;fica</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, seleccione una opci&oacute;n:</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <form>
                                                <div className="p-4 border-top">
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaMin" className="form-label">
                                                                Desde la fecha
                                                            </Label>
                                                            <Input
                                                                value={this.state.fechaMin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaMin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaFin" className="form-label">
                                                                Hasta la fecha
                                                            </Label>
                                                            <Input
                                                                value={this.state.fechaFin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaFin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="solicitar_a" className="form-label">
                                                                Departamento/Área
                                                            </Label>
                                                            <Select
                                                                name="solicitar_a"
                                                                options={this.state.departamentosAreas}
                                                                value={this.state.solicitar_a}
                                                                onChange={this.cambiosSolicitarA}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="tipo_solicitud" className="form-label">
                                                                Tipo de solicitud
                                                            </Label>
                                                            <Select
                                                                name="tipo_solicitud"
                                                                options={this.state.tiposSolicitudes}
                                                                value={this.state.tipo_solicitud}
                                                                onChange={this.cambiosSolicitud}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="lugar_ubicacion" className="form-label">
                                                                Ubicación
                                                            </Label>
                                                            <Select
                                                                name="lugar_ubicacion"
                                                                options={this.state.ubicaciones}
                                                                value={this.state.lugar_ubicacion}
                                                                onChange={this.cambiosUbicacion}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Row>
                                                            <Col>
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                                    Buscar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.descargarExcel}>
                                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                                    Exportar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                                    Borrar Filtros
                                                                </MDBBtn>
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                    {' '}
                                                </div>
                                            </form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <div className='header'>
                                        <h1 className='title'>Grafica De Tiempo</h1>
                                        <div className='links'>
                                            Grafica de Solicitudes en Base a Tiempo
                                        </div>
                                    </div>
                                    <Pie data={this.state.data} options={this.state.opciones} />
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}